<template>
    <div class="sales-filter-count">
        <div class="container">
            <div class="filter-items-counter">
                <strong v-if="globalLang != 'kz/'">Найдено {{ filterSalesDataBase.filter_items_count }} 
                    <span v-if="filterSalesDataBase.filter_items_count == 1">проект</span>
                    <span v-if="filterSalesDataBase.filter_items_count == 2 || filterSalesDataBase.filter_items_count == 3 || filterSalesDataBase.filter_items_count == 4">проекта</span>
                    <span v-if="filterSalesDataBase.filter_items_count > 4">проектов</span>
                </strong> 
                <strong v-else>{{ filterSalesDataBase.filter_items_count }} жоба табылды</strong>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sales-filter-count',
        components: {
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                routerName: this.$router.history.current.name,
            }
        },
        computed: mapGetters({
            filterSalesDataBase: 'loadFilterSalesData',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/filters/sales-projects/sales-filter-count.scss';
</style>